import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import { fetchModule, updateModule } from '../actions/modules'
import { renderInputField, renderTextAreaField, renderSelectField } from '../utils/forms'

class ModuleEditForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { modules, fetchModule, match } = this.props

    if (!modules.module) {
      fetchModule(match.params.Code)
    } else {
      this.setState({ loaded: true })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.modules.module) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const { updateModule, modules } = this.props

    return updateModule(modules.module.Code, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  renderPairing(props) {
    const { fields } = props

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Index</th>
                <th scope="col">Número de serie</th>
                <th scope="col">PIN</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((registerlocker, index) => (
                <tr key={index}>
                  <td>
                    {index +1}
                  </td>
                  <td>
                    <Field
                      name={`${registerlocker}.SN`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${registerlocker}.Pin`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button className="btn btn-danger mr-1" type="button"
                      onClick={() => fields.remove(index)}>
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button className="btn bg-vw-light text-white" type="button"
            onClick={() => fields.push({})}>
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { modules, error, pristine, submitting, handleSubmit } = this.props

    if (!this.state.loaded) {
      if (modules.error) {
        return (
          <ErrorMessage message={modules.error.message} />
        )
      }

      return (
        <div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <h1>
          <span className="text-vw-dark">EDITAR </span>
          <span className="text-vw-light">MÓDULO</span>
        </h1>
        <hr className="bg-vw-light" />
        <div className="row">
          <div className="col">
            <Box title="Configuración" icon="cubes">
              <Field name="Code"
                type="text"
                component={renderInputField}
                label="Número de Serie" />
              <FieldArray name="RegisterLockers" component={this.renderPairing} />
            </Box>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <button className="btn bg-vw-light text-white mr-1 save" type="submit"
          disabled={pristine || submitting}>
          Guardar
        </button>
      </form>
    )
  }
}

ModuleEditForm = reduxForm({
  form: 'ModuleEditForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/modules/${result.response.Code}`)
  }
})(ModuleEditForm)

const mapStateToProps = state => ({
  modules: state.modules,
  initialValues: state.modules.module
})

const mapDispatchToProps = dispatch => ({
  fetchModule: bindActionCreators(fetchModule, dispatch),
  updateModule: bindActionCreators(updateModule, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ModuleEditForm)


